// Module
var code = "<!-- ko using: icon -->\n<svg data-bind=\"attr: {\n  viewBox: viewBox,\n}\">\n  <use data-bind=\"attr: {\n    href: '#' + id,\n    'xlink:href': '#' + id\n  }\"></use>\n</svg>\n<!-- /ko -->\n";
// Exports
module.exports = code;